// src/store/useStore.js
import { create } from "zustand";
import { getAuth } from "firebase/auth";

// Load user profile from localStorage if available
const loadUserProfile = () => {
  const storedProfile = localStorage.getItem("userProfile");
  return storedProfile ? JSON.parse(storedProfile) : null;
};

const useStore = create((set, get) => ({
  // User Profile State
  userProfile: loadUserProfile(),
  setUserProfile: (incomingUserProfile) => {
    if (incomingUserProfile) {
      const userProfile = { ...incomingUserProfile };
      // Ensure the userProfile contains the currentUser.uid
      if (!userProfile.uid) {
        const auth = getAuth();
        const currentUser = auth.currentUser;
        if (currentUser && currentUser.uid) {
          userProfile.uid = currentUser.uid;
        }
      }
      // Persist before the dedupe check, not after: the stored copy is what
      // the next page load hydrates from, and skipping the write whenever the
      // in-memory profile happened to match left callers persisting their own
      // (uid-less) copy instead. This store is the only writer of the key.
      localStorage.setItem("userProfile", JSON.stringify(userProfile));
      const existingProfile = get().userProfile || null;
      if (JSON.stringify(existingProfile) === JSON.stringify(userProfile)) {
        return;
      }
      set({ userProfile });
    } else {
      console.warn("Attempting to set undefined userProfile");
    }
  },

  clearUserProfile: () => {
    // Clear localStorage items related to the user
    localStorage.removeItem("userProfile");
    localStorage.removeItem("authResponseData");
    localStorage.removeItem("mapCenter");
    localStorage.removeItem("userLocation");

    // localStorage.removeItem("__paypal_storage__");
    localStorage.removeItem("kbeanToken");
    localStorage.removeItem("artworkData");
    set({ userProfile: null });
  },
}));

export default useStore;
